import React from 'react'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CREATE_3DSCAN_APPOINTMENT } from '../../ui-definition/process-ui'

const Create3DScanAppointment = ({ customer }) => {
    if (!customer || !currentUserHasAccess(CREATE_3DSCAN_APPOINTMENT)) {
        return null
    }

    return (
        <ContentBox title="Create 3D Scan Appointment">
            <Row>
                <Column size={12}>
                    {customer.rescanBookingUrl && (
                        <a
                            href={customer.rescanBookingUrl}
                            className="btn btn-danger btn-sm"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Create 3D-Scan Appointment&#160;
                            <i className="fa fa-external-link" />
                        </a>
                    )}
                </Column>
            </Row>
        </ContentBox>
    )
}

export default Create3DScanAppointment



// WEBPACK FOOTER //
// ./src/modules/process/component/task-detail/Create3DScanAppointment.js